import { changesDigitalData } from '@/utils/digitalData';
import { listingItem } from '@/utils/formatters/formattedDigitalDataManager';

const useListing = () => {
  /**
   * Обновляет объект listing в digitalData
   * @param {Array} items
   * @param {Object} payload
   * @param {Array} [payload.category]
   * @param {string} [payload.categoryId]
   * @param {number} payload.currentPage
   * @param {string} [payload.layout=grid] - grid
   * @param {string} [payload.listName=category] - category|search
   * @param {number} payload.pagesCount
   * @param {string} payload.query
   * @param {number} payload.resultCount
   * @param {string} payload.sortBy
   */
  const changeListing = (items = [], payload = {}) => {
    const resultData = {
      currentPage: payload.currentPage,

      // TODO: перенос
      items: items.map(item => listingItem(item)),
      layout: 'grid',
      listId: 'main',
      listName: 'category',
      query: payload.query,
      resultCount: payload.resultCount,
    };

    if (payload.category) resultData.category = payload.category;
    if (payload.categoryId) resultData.categoryId = payload.categoryId;
    if (payload.layout) resultData.layout = payload.layout;
    if (payload.listName) resultData.listName = payload.listName;
    if (payload.sortBy) resultData.sortBy = payload.sortBy;
    if (payload.pagesCount) resultData.pagesCount = payload.pagesCount;

    changesDigitalData(['listing', resultData, 'book24']);
  };

  const clearListing = () => {
    changesDigitalData(['listing', undefined, 'book24']);
  };

  return { changeListing, clearListing };
};

export default useListing;
